import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

import {environment} from '../../../../environments/environment';
import { Observable } from "rxjs";
import { publicDecrypt } from 'crypto';

const _ = require('lodash');

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private SERVER_URL = `${environment.API_URL}`;

  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService
  ) {}

  public getLoggedInUser() {
    const userId = localStorage.getItem('userId') || this.cookieService.get('UserId');
    if (userId) {
      return this.getUser(userId);
    }
    return null;
  }

  public getUser(userId: string): Observable<any> {
    const params = new  HttpParams()
      .set('userId', userId);

    return this.httpClient.get(this.SERVER_URL + 'user/user/getUser', {params});
  }

  public getTeamLeadUserByTeamId(teamId: string): Observable<any> {
    const params = new  HttpParams()
      .set('teamId', teamId);

    return this.httpClient.get(this.SERVER_URL + 'user/user/getTeamLeadUserByTeamId', {params});
  }

  public getUsers(): Observable<any> {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'user/user/getUsers', {params});
  }

  public getAllUsers() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'user/user/getAllUsers', {params});
  }

  public getUsersForClientFilter() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'user/user/getUsersForClientFilter', {params});
  }

  public getUsersForSalaries(month, year) {
    const params = new  HttpParams()
      .set('month', month)
      .set('year', year);

    return this.httpClient.get(this.SERVER_URL + 'user/user/getUsersForSalaries', {params});
  }

    public getTichete(month, year) {
        const params = new  HttpParams()
            .set('month', month)
            .set('year', year);

        return this.httpClient.get(this.SERVER_URL + 'user/user/getTichete', {params});
    }

    public getUsersForTichete() {
        return this.httpClient.get(this.SERVER_URL + 'user/user/getUsersForTichete', {});
    }

  public getTeams() {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'user/user/getTeams', {params});
  }

  public getTeamsDec2022() {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'user/user/getTeamsDec2022', {params});
  }

    public getTeamsByMonth(month, year): Observable<any> {
    const params = new  HttpParams()
        .set('month', month)
        .set('year', year);

        return this.httpClient.get(this.SERVER_URL + 'user/user/getTeamsByMonth', {params});
    }

  public saveTeam(data: any, userId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'user/user/saveTeam',
        {
          data,
          userId: userId
        },
        { headers });
  }

  public updateTeam(data: any, userId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'user/user/updateTeam',
        {
          data
        },
        { headers });
  }

  public deleteTeam(teamId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'user/user/deleteTeam',
        {
          teamId
        },
        { headers });
  }


  public saveUser(data: any, userId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'user/user/saveUser',
        {
          data,
          userId: userId
        },
        { headers });
  }

  public updateUser(data: any, userId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'user/user/updateUser',
        {
          data
        },
        { headers });
  }

    public setSalary(data: any, month, year) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'user/user/setSalary',
            {
                data, month, year
            },
            { headers });
    }

  public deleteUser(userId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'user/user/deleteUser',
        {
          userId
        },
        { headers });
  }

  public movePortofolio(userFromId: any, userToId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'user/user/movePortofolio',
        {
          userFromId,
          userToId
        },
        { headers });
  }

  public copyPermissions(userFromId: any, userToId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'user/user/copyPermissions',
        {
          userFromId,
          userToId
        },
        { headers });
  }

  public sendResetRequest(email: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    return this.httpClient.post(this.SERVER_URL + 'auth/auth/resetRequest',
      { email },
      { headers });
  }

  public resetPassword(token: string, password: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    return this.httpClient.post(this.SERVER_URL + 'auth/auth/resetPassword',
      { token, password },
      { headers });
  }


  public downloadPayrollPdf(clientId, month, year) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    return this.httpClient.post(this.SERVER_URL + `worksheet/worksheet/downloadPayrollPdf`,
      { clientId, month, year },
      { headers, responseType: 'blob', observe: 'response' as 'body' }
    );
  }

  public uploadPayrollPdf(clientId, month, year, file:string){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/uploadPayrollPdf',
      {clientId, month, year, file},
      { headers });

  }
    
  public deletePayrollPdf(clientId, month, year) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    return this.httpClient.post(this.SERVER_URL + `worksheet/worksheet/deletePayrollPdf`,
      { clientId, month, year },
      { headers }
    );
  }


 

 
}
